export default "__VITE_ASSET__66e59b13__"